function omPartitionDescription(root) {
  if (root.hasAttribute('data-om-partitioned')) return;
  const description = root.querySelector('[data-om-pdp-description]');
  if (!description) return;
  let destination = description;
  const nodes = Array.from(description.childNodes);
  for (const node of nodes) {
    if (node.nodeType === 1 && (/^H[1-6]$/.test(node.tagName) || (node.tagName === 'P' && node.childElementCount === 1 && /^(STRONG|B)$/.test(node.firstElementChild.tagName) && node.textContent.trim() === node.firstElementChild.textContent.trim()))) {
      const label = node.textContent.trim().toLowerCase();
      if (/^(fit information|size\s*(?:&|and)\s*fit|sizing|size guide|fit|معلومات المقاس|المقاس والملاءمة|المقاس|المقاسات|القياس)\s*[:：]?$/.test(label)) destination = root.querySelector('[data-om-pdp-content="sizefit"]');
      else if (/^(key features|product details|design details|details|features|التفاصيل|تفاصيل المنتج|تفاصيل التصميم|المميزات|المزايا|المواصفات|الخامات)\s*[:：]?$/.test(label)) destination = root.querySelector('[data-om-pdp-content="designdetails"]');
      else destination = description;
    }
    if (destination && destination !== description) destination.append(node);
  }
  root.querySelectorAll('[data-om-pdp-content]').forEach((target) => {
    if (target.textContent.trim()) target.parentElement.querySelectorAll('[data-om-pdp-empty]').forEach((el) => el.remove());
  });
  root.setAttribute('data-om-partitioned','');
}
class OmPdpSticky extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.omForm);
    this.info = document.querySelector(`[data-om-product-info="${CSS.escape(this.dataset.omForm)}"]`);
    if (!this.form || !this.info) return;
    this.abort = new AbortController();
    this.button = this.querySelector('[data-om-sticky-action]');
    this.button.addEventListener('click', () => {
      if (!window.omPdpSelection?.ready(this.form)) {
        window.omPdpSelection?.focus(this.form);
        return;
      }
      const submit = this.form.querySelector('button[type="submit"]');
      if (submit && !submit.disabled) this.form.requestSubmit(submit);
    }, {signal:this.abort.signal});
    this.update = () => {
      const sizeInput = this.info.querySelector('.om-pdp-size-option input[data-option-position]:checked');
      const submit = this.form.querySelector('button[type="submit"]');
      const price = this.info.querySelector('[data-block-type="price"] price-list');
      const priceTarget = this.querySelector('[data-om-sticky-price]');
      if (price && priceTarget.innerHTML !== price.outerHTML) priceTarget.innerHTML = price.outerHTML;
      const label = submit?.textContent.trim();
      if (label && this.button.textContent !== label) this.button.textContent = label;
      this.button.disabled = !submit || submit.disabled;
      const availability = this.info.querySelector('[data-om-availability]');
      const state = availability?.querySelector('[data-om-availability-selected]')?.textContent.trim();
      const status = this.querySelector('[data-om-sticky-status]');
      const sizeLabel = sizeInput ? `${this.info.querySelector('.om-pdp-size-option legend')?.textContent.trim().replace(/:$/, '') || ''} ${sizeInput.labels?.[0]?.textContent.trim() || ''}`.trim() : '';
      const statusText = [sizeLabel, state].filter(Boolean).join(' · ');
      if (statusText !== status.textContent) status.textContent = statusText;
      const rect = this.form.getBoundingClientRect();
      this.hidden = !(matchMedia('(max-width:999px)').matches && rect.bottom < 0);
      document.body.classList.toggle('om-pdp-has-sticky',!this.hidden);
      if (!this.hidden) document.documentElement.style.setProperty('--om-pdp-sticky-height',`${this.offsetHeight}px`);
    };
    this.mutations = new MutationObserver(this.update);
    this.mutations.observe(this.info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','hidden']});
    this.form.addEventListener('om:size-state',this.update,{signal:this.abort.signal});
    window.addEventListener('scroll',this.update,{passive:true,signal:this.abort.signal});
    window.addEventListener('resize',this.update,{passive:true,signal:this.abort.signal});
    this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.mutations?.disconnect();document.body.classList.remove('om-pdp-has-sticky');}
}
if(!customElements.get('om-pdp-sticky'))customElements.define('om-pdp-sticky',OmPdpSticky);
const omCompactNativeBlocks = () => {
  document.querySelectorAll('.om-pdp .product-info__block-list > .product-info__block-item').forEach((block) => {
    block.removeAttribute('data-om-empty-block');
    if (block.matches('[data-block-type="payment-terms"],[data-block-id*="tabby"]')) return;
    if (block.getBoundingClientRect().height === 0) block.setAttribute('data-om-empty-block', '');
  });
  document.querySelectorAll('.om-pdp variant-picker').forEach((picker) => {
    const size = picker.querySelector('.om-pdp-size-option');
    const info = picker.closest('[data-om-product-info]');
    const help = info?.querySelector('.om-size-help');
    let heading = size?.querySelector('.variant-picker__option-info');
    if (size && !heading) {
      heading = document.createElement('div');
      heading.className = 'variant-picker__option-info h-stack justify-between gap-2';
      const legend = size.querySelector('legend');
      size.prepend(heading);
      if (legend) heading.append(legend);
    }
    if (size && help && help.parentElement !== size) size.append(help);
    const chart = picker.querySelector('.ks-chart-container');
    if (heading && chart) {
      let labelGroup = heading.querySelector('[data-om-size-label-group]');
      if (!labelGroup) {
        const legend = heading.querySelector('legend');
        if (legend) {
          if (legend.parentElement !== heading) {
            labelGroup = legend.parentElement;
          } else {
            labelGroup = document.createElement('div');
            heading.prepend(labelGroup);
            labelGroup.append(legend);
          }
          labelGroup.setAttribute('data-om-size-label-group', '');
        }
      }
      if (labelGroup && chart.parentElement !== labelGroup) labelGroup.append(chart);
    }
    const label = picker.closest('[data-om-product-info]')?.dataset.omSizeGuide;
    const text = chart?.querySelector('._ks_text');
    if (label && text && text.textContent !== label) {
      text.textContent = label;
      chart.querySelector('button')?.setAttribute('aria-label', label);
    }
  });
};
const omEnhanceDetails = (scope=document) => {
  omCompactNativeBlocks();
  if(scope instanceof Element && scope.matches('[data-om-pdp-details]'))omPartitionDescription(scope);
  scope.querySelectorAll?.('[data-om-pdp-details]').forEach(omPartitionDescription);
  document.querySelectorAll('a[href*="wa.me/"],a[href*="api.whatsapp.com/"],#chwhatsapp-btn').forEach((link)=>{
    let parent=link;
    for(let i=0;parent&&i<5;i++,parent=parent.parentElement){
      if(getComputedStyle(parent).position==='fixed'){parent.setAttribute('data-om-whatsapp-floating','');break;}
    }
  });
};
omEnhanceDetails();
let omEnhanceScheduled = false;
new MutationObserver(() => {
  if (omEnhanceScheduled) return;
  omEnhanceScheduled = true;
  requestAnimationFrame(() => {
    omEnhanceScheduled = false;
    omEnhanceDetails();
  });
}).observe(document.body, {childList: true, subtree: true});

(() => {
  const rootSelector = '[data-om-pdp-details]';

  const initialize = (root) => {
    if (root.hasAttribute('data-om-pdp-ready')) return;

    const tabs = Array.from(root.querySelectorAll('[data-om-pdp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-om-pdp-panel]'));
    if (tabs.length !== 4 || panels.length !== 4) return;

    const select = (selectedTab, focus = false) => {
      const key = selectedTab.dataset.omPdpTab;
      tabs.forEach((tab) => {
        const selected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.omPdpPanel !== key;
      });
      if (focus) selectedTab.focus({ preventScroll: true });
    };

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-om-pdp-tab]');
      if (tab && tabs.includes(tab)) select(tab);
    });

    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-om-pdp-tab]');
      if (!tab || !tabs.includes(tab)) return;
      const current = tabs.indexOf(tab);
      const rtl = getComputedStyle(root).direction === 'rtl';
      let next;
      switch (event.key) {
        case 'ArrowRight':
          next = (current + (rtl ? -1 : 1) + tabs.length) % tabs.length;
          break;
        case 'ArrowLeft':
          next = (current + (rtl ? 1 : -1) + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      select(tabs[next], true);
    });

    select(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
    root.setAttribute('data-om-pdp-ready', '');
  };

  const initializeWithin = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;
    if (scope instanceof Element && scope.matches(rootSelector)) initialize(scope);
    scope.querySelectorAll(rootSelector).forEach(initialize);
  };

  const start = () => {
    initializeWithin(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(initializeWithin));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
